import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";

export default function AppSkeleton() {
  if (window.location.pathname === "/") {
    return (
      <div className="App">
        <div className="landingPageGradient gradient" />
        <div style={{ height: 20 }}></div>
        <div className="landingPageLogo" style={{ background: "none" }}>
          <Skeleton
            variant="rect"
            width={220}
            height={100}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.13)",
            }}
          />
        </div>
        <div style={{ height: 20 }}></div>
        <div className="landingPageFluid landingPageFluidDirection">
          <div style={{ margin: 10 }}>
            <Skeleton
              variant="rect"
              width={200}
              height={150}
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.13)",
              }}
            />
          </div>
          <div style={{ margin: 10 }}>
            <Skeleton
              variant="rect"
              width={200}
              height={150}
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.13)",
              }}
            />
          </div>
          <div style={{ margin: 10 }}>
            <Skeleton
              variant="rect"
              width={200}
              height={150}
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.13)",
              }}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="App">
        <div className="landingPageGradient gradient" />
        <div style={{ height: 20 }}></div>
        <div className="landingPageLogo" style={{ background: "none" }}>
          <Skeleton
            variant="rect"
            width={220}
            height={100}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.13)",
            }}
          />
        </div>
        <div style={{ height: 20 }}></div>
        <div style={{ padding: 20 }}>
          <Skeleton
            variant="rect"
            height={250}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.13)",
            }}
          />
        </div>
        <div style={{ height: 20 }}></div>
        <div>
          <Skeleton
            variant="rect"
            width={500}
            height={250}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.13)",
              margin: "auto",
            }}
          />
        </div>
      </div>
    );
  }
}
